export class AvailableDay {

  constructor() {
  }

  static get TYPES() {
    return {
      AGREEMENT : 'AGREEMENT',
      FREE      : 'FREE',
      CHRISTMAS : 'CHRISTMAS',
    };
  }

  static getTranslation(key) {
    const TRANSLATIONS = {};
    TRANSLATIONS[this.TYPES.AGREEMENT] = 'VACATIONS_ABSENCES.GENERAL.AGREEMENT';
    TRANSLATIONS[this.TYPES.FREE]      = 'VACATIONS_ABSENCES.GENERAL.FREE';
    TRANSLATIONS[this.TYPES.CHRISTMAS] = 'VACATIONS_ABSENCES.GENERAL.CHRISTMAS';

    return TRANSLATIONS[key];
  }
}



// WEBPACK FOOTER //
// ./client/app/common/domain/models/availableDayTypes.js